import { keys, random } from 'lodash';


interface EvalFunction {
    (lodashKeys: Function, contextObject: object): any
}


function evalInContext(expr: string, context: object): any {
    let argString = `keys, {${keys(context).join(',')}}`;
    let test = Function(argString, `return ${expr};`) as EvalFunction;
    try {
        return test(keys, context);
    } catch (e) {
        return null;
    }
}

/* istanbul ignore next */
function randomChoice<T>(choices: T[]): T {
    let index = random(0, choices.length - 1);
    return choices[index];
}


export function uuid(){return(""+1e7+-1e3+-4e3+-8e3+-1e11).replace(/1|0/g,function(){return(0|Math.random()*16).toString(16)})}

export {
    evalInContext,
    randomChoice
}
